import commonUseCSR from '../../composables/useCSR'

export default function useCSR(context) {
  // liveChat
  // const { initLivechatCSRWidget, openLivechatCSRWidget } = commonUseCSR(context)
  //
  // function initCSRWidget() {
  //   initLivechatCSRWidget()
  // }
  // function openCSRWidget() {
  //   openLivechatCSRWidget()
  // }
  //
  // return {
  //   initCSRWidget,
  //   openCSRWidget
  // }

  // zendesk
  const {
    initZendeskCSRWidget,
    loginZendeskCSRWidget,
    logoutZendeskCSRWidget,
    openZendeskCSRWidget
  } = commonUseCSR(context)

  function initCSRWidget() {
    initZendeskCSRWidget()
  }
  function loginCSRWidget() {
    loginZendeskCSRWidget()
  }
  function logoutCSRWidget() {
    logoutZendeskCSRWidget()
  }
  function openCSRWidget() {
    openZendeskCSRWidget()
  }

  return {
    initCSRWidget,
    loginCSRWidget,
    logoutCSRWidget,
    openCSRWidget
  }
}
